const TRUEFALSE = [
	{ fr: 'Vrai', en: 'True', bool: true, id: 1 },
	{ fr: 'Faux', en: 'False', bool: false, id: 2 },
]
export default TRUEFALSE
